<div class="main-page-loader-logo-container display-flex justify-content-center w-100">
  <ng-lottie *ngIf="options" [options]="options" [width]="attrWidth" [height]="attrHeight"></ng-lottie>
</div>
